import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EventCreatePage } from './event-create';
import { DirectivesModule } from '../../directives/directives.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    EventCreatePage,
  ],
  imports: [
    DirectivesModule,
		PipesModule,
    IonicPageModule.forChild(EventCreatePage),
  ],
})
export class EventCreatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/event-create/event-create.module.ts